import PropTypes from 'prop-types';
import { createContext, useContext } from 'react';
import useScannerWizardActions from '@hooks/scanner-context/useScannerWizardActions';
import useScannerWizardEffects from '@hooks/scanner-context/useScannerWizardEffects';
import useScannerWizardState from '@hooks/scanner-context/useScannerWizardState';

export const ScannerWizardContext = createContext(null);

const ScannerWizardContextProvider = ({ children }) => {
	const state = useScannerWizardState();
	const actions = useScannerWizardActions(state);
	useScannerWizardEffects(state, actions);

	const value = { ...state, ...actions };

	return (
		<ScannerWizardContext.Provider value={value}>
			{children}
		</ScannerWizardContext.Provider>
	);
};

ScannerWizardContextProvider.propTypes = {
	children: PropTypes.node,
};

export default ScannerWizardContextProvider;
export const useScannerWizardContext = () => useContext(ScannerWizardContext);
